import React from "react";
import { components } from "react-select";
import { IE11Flexbug3Fix } from "./IE11Flexbug3Fix";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const IndicatorsContainer: typeof components.IndicatorsContainer = ({ children, ...props }) => {
    return (
        <IE11Flexbug3Fix>
            <components.IndicatorsContainer {...props}>{children}</components.IndicatorsContainer>
        </IE11Flexbug3Fix>
    );
};
